module.exports = "<div>\n    <h4 class=\"panel-title\" style=\"padding: 5px;\">\n        <a class=\"title-toggle\" data-toggle=\"collapse\" data-parent=\"#accordion\" [href]=\"!disabled?'#collapse'+id:'#'\">\n            {{title}}\n        </a>\n\n        <div style=\"float: right;\">\n            <ng-content></ng-content>\n        </div>\n    </h4>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/collapse/child/header/collapse.form.header.template.html
// module id = 952
// module chunks = 0